const SUPPORT_WHATSAPP_NUMBER = '918047358900';

// The prefilled text is only a convenience for the customer -- they can edit
// or delete it. Attribution to the Support category happens server-side: the
// tap is logged with the user's phone (useLogChatWithUsClick) and chatbot
// matches the WhatsApp message by phone, not by this text.
export const buildSupportWhatsappLink = (
  category: string,
  subCategory: string,
): string => {
  const base = `https://wa.me/${SUPPORT_WHATSAPP_NUMBER}`;
  const topic = [category, subCategory].filter(Boolean).join(' → ');
  if (!topic) {
    return base;
  }
  return `${base}?text=${encodeURIComponent(`Hi, I need help with ${topic}`)}`;
};
